import {API_ROOT_URL} from 'envs/_current/config'

export const appLog_recordPageView_Api = {
  backend: `Route::post('app-log/page-view', 'AppController@recordPageView');`,
  root: API_ROOT_URL,
  path: '/app-log/page-view',
  method: 'POST',
  paramsFields: ['page_key'],
}

export const appLog_getPageViewStats_Api = {
  backend: `Route::get('app-log/page-view-stats', 'AppController@getPageViewStats');`,
  root: API_ROOT_URL,
  path: '/app-log/page-view-stats',
  method: 'GET',
  paramsFields: ['type'],
}

export const appLog_getJobSyncStatus_Api = {
  backend: `Route::get('app-log/job-sync-status', 'AppController@getJobSyncStatus');`,
  root: API_ROOT_URL,
  path: '/app-log/job-sync-status',
  method: 'GET',
  paramsFields: ['type'],
}
